import type { FinancialReportType } from "./types";

export const REPORT_DEFINITIONS: Record<FinancialReportType, { title: string; group: "综合财务分析" | "财务风险识别" | "行业经营对标"; endpointFamily: "common" | "dressing" | "account-movement" | "industry-comparison"; reportId?: string }> = {
  detail: { title: "财务分析详细报告", group: "综合财务分析", endpointFamily: "common", reportId: "1" },
  diagnosis: { title: "问题诊断报告", group: "综合财务分析", endpointFamily: "common", reportId: "4" },
  decision: { title: "决策水平报告", group: "综合财务分析", endpointFamily: "common", reportId: "25" },
  "capital-chain": { title: "资金断链分析", group: "综合财务分析", endpointFamily: "common", reportId: "47" },
  "industry-gap": { title: "行业比对差异报告", group: "综合财务分析", endpointFamily: "common", reportId: "41" },
  dressing: { title: "报表粉饰分析报告", group: "财务风险识别", endpointFamily: "dressing" },
  "account-movement": { title: "科目异动分析报告", group: "财务风险识别", endpointFamily: "account-movement" },
  "industry-benchmark": { title: "行业比较分析报告", group: "行业经营对标", endpointFamily: "industry-comparison" },
};
